import React from "react";
import { withStyles } from "@material-ui/core/styles";
import MuiExpansionPanel from "@material-ui/core/ExpansionPanel";
import MuiExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import MuiExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";
import StrukturaCard from "../../components/Struktura";
import { Row, Col } from "reactstrap";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
const ExpansionPanel = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0
    },
    "&:before": {
      display: "none"
    },
    "&$expanded": {
      margin: "auto"
    }
  },
  expanded: {}
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    backgroundColor: "rgba(0, 0, 0, .03)",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: -1,
    minHeight: 56,
    "&$expanded": {
      minHeight: 56
    }
  },
  content: {
    "&$expanded": {
      margin: "12px 0"
    }
  },
  expanded: {}
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles(theme => ({
  root: {}
}))(MuiExpansionPanelDetails);

class CustomizedExpansionPanels extends React.Component {
  state = {};
  componentWillMount() {
    this.setState({ data: this.props.data });
  }

  handleChange = panel => (event, newExpanded) => {
    this.setState({ expanded: newExpanded ? panel : false });
  };
  componentWillReceiveProps(props) {
    this.setState({ data: props.data });
  }
  render() {
    const data = this.state.data;
    let history = this.props.history;
    return (
      <div>
        {data.map((row, index) => {
          return (
            <ExpansionPanel
              square
              style={{ justifyContent: "center" }}
              expanded={this.state.expanded === "panel" + index}
              onChange={this.handleChange("panel" + index)}
              className="collapse-cont"
            >
              <ExpansionPanelSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
                style={{
                  justifyContent: "space-between",
                  display: "flex",
                  width: "100%"
                }}
              >
                <Typography
                  style={{
                    display: "flex"
                  }}
                >
                  <div
                    className="collapse-row-title"
                    style={{
                      display: "flex"
                    }}
                  >
                    {row.name}
                  </div>
                </Typography>
                <Typography
                  style={{
                    display: "flex",
                    marginLeft: "auto"
                  }}
                >
                  {!(this.state.expanded === "panel" + index) ? (
                    <FaAngleDown size={20} />
                  ) : (
                    <FaAngleUp size={20} />
                  )}
                </Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails
                style={{ display: "flex", justifyContent: "center" }}
              >
                <Row style={{ width: "100%" }}>
                  {row.struktura.map(strukture => {
                    console.log(strukture);
                    const { emri, pershkrimi, id } = strukture;
                    return (
                      <Col xs="12" sm="6" md="4" lg="3">
                        <StrukturaCard
                          title={emri}
                          sub={pershkrimi}
                          id={id}
                          history={history}
                        />
                      </Col>
                    );
                  })}
                </Row>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          );
        })}
      </div>
    );
  }
}

export default CustomizedExpansionPanels;
